
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.75 8.366H5.25A1.25 1.25 0 004 9.616V21.06c0 .688.557 1.25 1.25 1.25h19.5A1.25 1.25 0 0026 21.06V9.616a1.253 1.253 0 00-1.25-1.25zm-6.999 2.626c0-.171.14-.31.31-.31h1.273c.17 0 .31.139.31.31v1.25c0 .17-.14.31-.31.31H18.06a.31.31 0 01-.31-.31v-1.25zm-1.546 3.393h1.272c.17 0 .31.14.31.31v1.25c0 .171-.14.31-.31.31h-1.272a.31.31 0 01-.31-.31v-1.25c0-.17.139-.31.31-.31zm-2.149-3.393c0-.171.14-.31.31-.31h1.272c.171 0 .31.139.31.31v1.25c0 .17-.139.31-.31.31h-1.272a.31.31 0 01-.31-.31v-1.25zm-1.55 3.393h1.271c.171 0 .31.14.31.31v1.25c0 .171-.139.31-.31.31h-1.272a.31.31 0 01-.31-.31v-1.25c0-.17.14-.31.31-.31zm-2.15-3.393c0-.171.14-.31.31-.31h1.273c.17 0 .31.139.31.31v1.25c0 .17-.14.31-.31.31h-1.273a.31.31 0 01-.31-.31v-1.25zm-3.717 0c0-.171.14-.31.31-.31H8.22c.17 0 .31.139.31.31v1.25c0 .17-.14.31-.31.31H6.95a.31.31 0 01-.31-.31v-1.25zm1.892 8.693c0 .171-.14.31-.31.31H6.95a.31.31 0 01-.31-.31v-1.25c0-.17.14-.31.31-.31H8.22c.17 0 .31.14.31.31v1.25zm1.529-3.43H8.787a.31.31 0 01-.31-.31v-1.25c0-.17.14-.31.31-.31h1.273c.17 0 .31.14.31.31v1.25c0 .171-.14.31-.31.31zm9.584 3.43c0 .171-.14.31-.31.31H10.67a.31.31 0 01-.31-.31v-1.25c0-.17.14-.31.31-.31h8.663c.17 0 .31.14.31.31v1.25zm1.528-3.43H19.9a.31.31 0 01-.31-.31v-1.25c0-.17.14-.31.31-.31h1.272c.17 0 .31.14.31.31v1.25c0 .171-.14.31-.31.31zm2.19 3.43c0 .171-.14.31-.31.31h-1.273a.31.31 0 01-.31-.31v-1.25c0-.17.14-.31.31-.31h1.272c.17 0 .31.14.31.31v1.25zm0-7.444c0 .171-.14.31-.31.31h-1.273a.31.31 0 01-.31-.31v-1.25c0-.17.14-.31.31-.31h1.272c.17 0 .31.14.31.31v1.25z","fill":"#fff"}})])
          )
        }
      }
    